import Swal from 'sweetalert2';
import { mensagemErro } from '../services/api';

// Feedback do sistema via SweetAlert2. Substitui o Snackbar do MUI:
// - toasts discretos no canto para sucesso/erro/aviso;
// - modal com lista quando o back devolve vários erros de validação.

const MODE_KEY = 'patio_theme_mode';
const ehEscuro = () => localStorage.getItem(MODE_KEY) === 'dark';

// Cores do toast/modal acompanham o tema claro/escuro do sistema.
export const coresTemaSwal = () => (ehEscuro()
    ? { background: '#17212C', color: '#E3F2FD' }
    : { background: '#FFFFFF', color: '#102A43' });

const escapar = (valor) => String(valor).replace(/[&<>"]/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]
));

// A AppBar é fixa e fica em z-index drawer+1 (1201); o container do SweetAlert2
// nasce em 1060, então a barra superior tampava o toast e o encostava no topo.
// Sobe o container acima da barra e o desloca para baixo dela.
const ajustarContainerAbaixoDaAppBar = (popup) => {
    const container = popup?.closest('.swal2-container');
    if (container) {
        container.style.zIndex = '1400';
        container.style.marginTop = '72px';
    }
};

const dispararToast = (icon, title) => Swal.fire({
    toast: true,
    position: 'top-end',
    icon,
    title,
    showConfirmButton: false,
    timer: 3500,
    timerProgressBar: true,
    didOpen: ajustarContainerAbaixoDaAppBar,
    ...coresTemaSwal(),
});

export const toastSucesso = (mensagem) => dispararToast('success', mensagem);
export const toastErro = (mensagem) => dispararToast('error', mensagem);
export const toastAviso = (mensagem) => dispararToast('warning', mensagem);
export const toastInfo = (mensagem) => dispararToast('info', mensagem);

// Extrai a lista estruturada de erros de campo (Bean Validation) do back.
const errosDeCampo = (error) => {
    const data = error?.response?.data;
    const lista = Array.isArray(data?.erros) ? data.erros
        : (Array.isArray(data) ? data : null);
    if (!lista?.length) return null;
    return lista.map((e) => e.mensagem || e.message || String(e)).filter(Boolean);
};

// Falha de operação: com vários erros de validação, abre modal com a lista;
// caso contrário, cai no toast de erro com a mensagem amigável do back.
export const alertaFalha = (error, padrao = 'Ocorreu um erro inesperado.') => {
    const lista = errosDeCampo(error);
    if (lista && lista.length > 1) {
        return Swal.fire({
            icon: 'error',
            title: 'Não foi possível salvar',
            html: `<ul style="text-align:left;margin:0;padding-left:1.2em">${
                lista.map((m) => `<li>${escapar(m)}</li>`).join('')
            }</ul>`,
            confirmButtonText: 'Entendi',
            confirmButtonColor: '#1565C0',
            ...coresTemaSwal(),
        });
    }
    return toastErro(mensagemErro(error, padrao));
};
